import { QueryKeys } from '@/constants/QueryKeys';
import { EnergyApi } from '@/utilities/api/EnergyApi';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

export type DashboardProgramMode = 'agronomy' | 'energy';

const AGRONOMY_ONLY = { agronomy: true, energy: false };

export const useDashboardProgram = (accessToken?: string | null) => {
  const [searchParams] = useSearchParams();
  const { data: energyData, isLoading } = useQuery(
    [QueryKeys.GET_ENERGY_DASHBOARD, accessToken],
    () => EnergyApi.getDashboard(accessToken!),
    {
      enabled: !!accessToken,
      // The endpoint answers 400 for non-members, so don't retry or refetch it on each mount.
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      retryOnMount: false,
      staleTime: 5 * 60 * 1000,
    },
  );
  const memberships = energyData?.memberships ?? AGRONOMY_ONLY;
  const isEnergyRequested = searchParams.get('program') === 'energy';
  const mode: DashboardProgramMode = energyData
    && (!memberships.agronomy || isEnergyRequested) ? 'energy' : 'agronomy';

  const excludeEnergyBalances = <T extends { subwalletId: string }>(balances: T[]) => {
    const energySubwalletIds = new Set(energyData?.energySubwalletIds);
    return balances.filter(({ subwalletId }) => !energySubwalletIds.has(subwalletId));
  };

  return {
    energyData,
    excludeEnergyBalances,
    isLoading: !!accessToken && isLoading,
    memberships,
    mode,
  };
};
